import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/quickbooks/:projectId/connect`;

export type ConnectQuickBooksResponse = {
  projectId: string;
};

export const getConnectQuickBooksUrl = (projectId: string | number) =>
  generateRoutePath(url, { projectId });

export const connectQuickBooks = ({
  projectId,
}: {
  projectId: string;
}): Promise<ConnectQuickBooksResponse> => {
  const URL = getConnectQuickBooksUrl(projectId);
  return axios.get(URL, { showError: false });
};

export const connectQuickBooksQueryKey = ['connect-quickbooks'];

type QueryFnType = typeof connectQuickBooks;

type UseConnectQuickBooksOptions = {
  projectId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useConnectQuickBooks = ({ projectId, config }: UseConnectQuickBooksOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...connectQuickBooksQueryKey, projectId],
    queryFn: () => connectQuickBooks({ projectId }),
    staleTime: Infinity,
    ...config,
  });
};
